import * as React from 'react';
import { FormGroup, Input } from 'reactstrap';
import { NumberFilterEditProps } from '../providers/SingleValue';
import { FiltersListAddButton } from './index';
import FilterEditRequiredValidation from './FilterEditRequiredValidation';

type SingleNumberFilterEditProps = NumberFilterEditProps & {
	step?: string;
};

interface SingleNumberFilterEditState {
	currentValue: string | null;
	displayValidationError: boolean;
}

/**
 * Configures a single number value in a filter. Used by Integer and Decimal field edit components.
 */
class SingleNumberFilterEdit extends React.PureComponent<SingleNumberFilterEditProps, SingleNumberFilterEditState> {
	constructor(props) {
		super(props);

		this.state = {
			currentValue: this.props.value ? this.props.value.toString() : '',
			displayValidationError: false,
		};
	}

	/**
	 * Bubbles up state to the parent component.
	 *
	 * @private
	 * @memberof SingleNumberFilterEdit
	 */
	private handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		this.setState({
			currentValue: e.currentTarget.value,
		});
	};

	private sendUpdatedValue = () => {
		const { currentValue } = this.state;

		const trimmedValue = currentValue ? currentValue.trim() : currentValue;

		const validationError = !this.props.filter.nullable && !trimmedValue;

		this.setState({
			displayValidationError: validationError,
		});

		if (!validationError) {
			this.props.onChange(this.state.currentValue, false);
		}
	};

	public render() {
		return (
			<>
				<FormGroup>
					<Input
						id="fieldValue"
						type="number"
						step={this.props.step}
						autoFocus
						placeholder={this.props.filter.nullable ? '<Empty>' : 'Enter a value to filter by'}
						value={this.state.currentValue || ''}
						onChange={this.handleOnChange}
					/>
				</FormGroup>
				<div className="filters-popover__actions">
					<FiltersListAddButton onClick={this.sendUpdatedValue} />
				</div>
				{this.state.displayValidationError ? (
					<FilterEditRequiredValidation messageOverride="Number field is required" />
				) : null}{' '}
			</>
		);
	}
}

export default SingleNumberFilterEdit;
